import { render, staticRenderFns } from "./EstablishmentForDisableSecondPartComp.vue?vue&type=template&id=92e2a804&scoped=true"
import script from "./EstablishmentForDisableSecondPartComp.vue?vue&type=script&lang=js"
export * from "./EstablishmentForDisableSecondPartComp.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentForDisableSecondPartComp.vue?vue&type=style&index=0&id=92e2a804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e2a804",
  null
  
)

/* custom blocks */
import block0 from "./EstablishmentForDisableSecondPartComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports